import EnLang from './entries/en-US';
import trLang from './entries/tr_TR';
import FrLang from './entries/fr-FR';
//import enRtlLang from './entries/en-US-rtl';
const AppLocale = {
    en: EnLang,
    tr: trLang,
    fr: FrLang,
  //  enrtl: enRtlLang,
  };
  
  export default AppLocale;
